module.exports = __webpack_public_path__ + "img/hotel2_4.b97d9209.png";